<div
  *ngIf="isOpened"
  class="modal-dialog-container"
  [ngClass]="{ 'modal-dialog-container--overlay': isOverlayEnabled }"
  (mousedown)="onOverlayMouseDown($event)"
  (mouseup)="onOverlayMouseUp($event)"
>
  <div class="modal-dialog-body" [ngClass]="{ 'modal-dialog-body--auto': isAutoWidth }">
    <div class="modal-dialog-header" *ngIf="isHeaderVisible">
      <span class="modal-dialog-title" data-qa="modal_dialog_title">{{ title }}</span>
      <button class="model-dialog-button-close" title="Close" data-qa="edit_contact_info_close_btn" *ngIf="isCloseButtonVisible" (click)="close()">
        <svg-icon-sprite
          [src]="'icon-times'"
          [width]="'14px'"
          [height]="'14px'"
          [classes]="'icon-default'"
        ></svg-icon-sprite>
      </button>
    </div>
    <ng-content></ng-content>
  </div>
</div>
